// extracted by mini-css-extract-plugin
export default {"tooltip":"gX-z","arrow":"hX-z"};